// // Live View Section Main Component
// import LiveviewMap from "../home/Map";

// export default function Liveview() {
//    return <LiveviewMap />;
// }
import React, { useEffect, useState } from "react";
import LiveviewMap from "../home/Map";
import VehicleCalibrationRemaindarBoard from "./VehicleCalibrationRemaindarBoard";

export default function Liveview() {
   const [showFeedback, setShowFeedback] = useState(false);

   useEffect(() => {
      // Trigger dialog open on mount (after login redirect)
      const today = new Date();
      const dayOfMonth = today.getDate();
      // Show dialog from 1st to 5th of every month
      const isFirstFiveDays = dayOfMonth >= 1 && dayOfMonth <=5;
      if (isFirstFiveDays) {
         setShowFeedback(true);
      }
   }, []);

   return (
      <>
         <LiveviewMap />

         {showFeedback && (
            <VehicleCalibrationRemaindarBoard openDialogByDefault={true} />
         )}
      </>
   );
}